module.exports = __webpack_public_path__ + "img/lift-panel-serro.39d6ff55.jpg";